module.exports = __webpack_public_path__ + "img/NZD.38cac85d.png";